import { useDispatch, useSelector } from "react-redux";

import {Typography} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import Grid from "@material-ui/core/Grid";
import FiltersSection from "../../Filters/FiltersSection";
import {makeStyles} from "@material-ui/core/styles";
import {  getRecebidosFinalizadosOS} from "../../../actions/orderActions"

import CircularProgress from "@material-ui/core/CircularProgress";
import RecebidoFinalizadoChart from "./recebidoFinalizadoChart";


const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const PainelProducao = ({

                    }) => {
    const classes = useStyles();

    const [show, setShow] = useState(false);
    const st = useSelector(state => state);
    console.log("REDUX STATE", st)
    const etapas = useSelector(state => state.stations.etapas);
    const recfin = useSelector(state => state.ordemServicoReducer.recebidosFinalizados);
    const isFetchingDiarioProducao = useSelector(state => state.ordemServicoReducer.isFetchingDiarioProducao);
    const periodMin = useSelector(state => state.filter.periodMin);
    const periodMax = useSelector(state => state.filter.periodMax);
    const loading = useSelector(state => state.ordemServicoReducer.isFetchingDiarioProducao)

    const dispatch = useDispatch();

    console.log("RECFIN", recfin);

    useEffect( () => {
        console.log("useEffect 0,0 getRecebidosFinalizadosOS");
        dispatch(getRecebidosFinalizadosOS());
    //    dispatch(getDiarioProducao());
    }, []);

    // useEffect(() => {
    //     dispatch(getRecebidosFinalizadosOS());
    // }, [periodMin]);
    //
    // useEffect(() => {
    //     dispatch(getRecebidosFinalizadosOS());
    // }, [periodMax]);


    const onFilterClick = () => {
        dispatch(getRecebidosFinalizadosOS());
    }

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.dashboardSection}>
                <Grid item xs={12}>
                    <FiltersSection showPeriod={true} showBeforePeriod={false} showBenchPeriod={false} onFilterClick={onFilterClick} loading={loading}  />
                </Grid>
            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>
                <Typography variant="h4" align="center" className={classes.sectionTitle}>
                    PRODUÇÃO
                </Typography>

            </Grid>
            <Grid item  xs={12} sm={12} lg={12} xl={12}>



                { isFetchingDiarioProducao &&
                    <React.Fragment>
                        <CircularProgress />
                    </React.Fragment>
                }


                <RecebidoFinalizadoChart series={recfin}/>





            </Grid>
        </React.Fragment>
    )

}

export default PainelProducao;
